export const DROPDOWN_MENU_VIEWPORT_GUTTER_PX = 8;
export const DROPDOWN_MENU_GAP_PX = 4;
export const DROPDOWN_MENU_MINIMUM_USEFUL_HEIGHT_PX = 160;
/** Tailwind `max-h-80` (20rem) at the default root font size. */
export const DROPDOWN_MENU_LIST_MAX_HEIGHT_PX = 320;
/** Fallback until the in-list search row has been measured. */
export const DROPDOWN_MENU_SEARCH_BLOCK_HEIGHT_PX = 56;

export type DropdownMenuSide = "below" | "above";

export type DropdownMenuPosition = {
  side: DropdownMenuSide;
  /** Top edge when the panel uses its full max height. */
  top: number;
  maxHeight: number;
  /** Set when the panel opens above, so a short list stays against the trigger. */
  bottom?: number;
};

type ResolveDropdownMenuPositionInput = {
  triggerTop: number;
  triggerBottom: number;
  viewportHeight: number;
  preferredPanelHeight: number;
  gutter?: number;
  gap?: number;
  minimumUsefulHeight?: number;
};

export function resolveDropdownMenuPosition(
  input: ResolveDropdownMenuPositionInput,
): DropdownMenuPosition {
  const gutter = input.gutter ?? DROPDOWN_MENU_VIEWPORT_GUTTER_PX;
  const gap = input.gap ?? DROPDOWN_MENU_GAP_PX;
  const minimumUsefulHeight =
    input.minimumUsefulHeight ?? DROPDOWN_MENU_MINIMUM_USEFUL_HEIGHT_PX;
  const spaceBelow = Math.max(
    0,
    input.viewportHeight - input.triggerBottom - gap - gutter,
  );
  const spaceAbove = Math.max(0, input.triggerTop - gap - gutter);
  const belowIsTooShort = spaceBelow < minimumUsefulHeight;
  const openAbove = belowIsTooShort && spaceAbove > spaceBelow;

  if (openAbove) {
    const maxHeight = Math.min(input.preferredPanelHeight, spaceAbove);
    return {
      side: "above",
      top: input.triggerTop - gap - maxHeight,
      maxHeight,
      bottom: input.viewportHeight - input.triggerTop + gap,
    };
  }

  return {
    side: "below",
    top: input.triggerBottom + gap,
    maxHeight: Math.min(input.preferredPanelHeight, spaceBelow),
  };
}
